import { ConfigEntity } from '../configStudio/configSubmission';
import { wizardLinks } from '../wizard/wizardLinks';

export type HistoryStatus = 'draft' | 'live' | 'in_review' | 'ended';

/** One configured record. No history API exists in v1 (backend ask): rows come from a fixture. */
export interface HistoryRow {
  /** The "CFG-nnnn" reference the design draws. */
  reference: string;
  /** The record's own id, for its page. */
  recordId: number;
  name: string;
  type: ConfigEntity;
  status: HistoryStatus;
  createdBy: string;
  updatedAt: string;
}

export type HistoryFilter = ConfigEntity | 'all';

export const HISTORY_FILTERS: HistoryFilter[] = ['all', 'campaign', 'rule', 'reward', 'audience'];

export const HISTORY_PAGE_SIZE = 8;

/** The record's page, from the shared route helper. */
export const historyRecordRoute = (row: HistoryRow): string => {
  switch (row.type) {
    case 'campaign':
      return wizardLinks.showCampaign(row.recordId);
    case 'rule':
      return wizardLinks.showRule(row.recordId);
    case 'reward':
      return wizardLinks.showReward(row.recordId);
    default:
      return wizardLinks.showAudience(row.recordId);
  }
};

/** Newest first, narrowed by type and by a name or reference search. */
export const filterHistory = (
  rows: HistoryRow[],
  filter: HistoryFilter,
  search: string
): HistoryRow[] => {
  const query = search.trim().toLowerCase();
  return rows
    .filter(row => filter === 'all' || row.type === filter)
    .filter(
      row =>
        query === '' ||
        row.name.toLowerCase().includes(query) ||
        row.reference.toLowerCase().includes(query) ||
        String(row.recordId) === query
    )
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
};
